import React from 'react';
import ApexCharts from 'apexcharts';
import PropTypes from 'prop-types';

window.React = React;
window.ApexCharts = ApexCharts;
window.PropTypes = PropTypes;

window.process = {
  env: {
    NODE_ENV: 'development'
  }
};
